/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Feedback_CancelInputs */

const en_feedback_cancel = /** @type {(inputs: Feedback_CancelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Cancel`)
};

const zh_hans1_feedback_cancel = /** @type {(inputs: Feedback_CancelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`取消`)
};

const pt_br2_feedback_cancel = /** @type {(inputs: Feedback_CancelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Cancelar`)
};

const es_feedback_cancel = /** @type {(inputs: Feedback_CancelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Cancelar`)
};

const fr_feedback_cancel = /** @type {(inputs: Feedback_CancelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Annuler`)
};

const de_feedback_cancel = /** @type {(inputs: Feedback_CancelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Abbrechen`)
};

const ru_feedback_cancel = /** @type {(inputs: Feedback_CancelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Отмена`)
};

const it_feedback_cancel = /** @type {(inputs: Feedback_CancelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Annulla`)
};

/**
* | output |
* | --- |
* | "Cancel" |
*
* @param {Feedback_CancelInputs} inputs
* @param {{ locale?: "en" | "zh-Hans" | "pt-BR" | "es" | "fr" | "de" | "ru" | "it" }} options
* @returns {LocalizedString}
*/
export const feedback_cancel = /** @type {((inputs?: Feedback_CancelInputs, options?: { locale?: "en" | "zh-Hans" | "pt-BR" | "es" | "fr" | "de" | "ru" | "it" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Feedback_CancelInputs, { locale?: "en" | "zh-Hans" | "pt-BR" | "es" | "fr" | "de" | "ru" | "it" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "zh-Hans") return zh_hans1_feedback_cancel(inputs)
	if (locale === "pt-BR") return pt_br2_feedback_cancel(inputs)
	if (locale === "es") return es_feedback_cancel(inputs)
	if (locale === "fr") return fr_feedback_cancel(inputs)
	if (locale === "de") return de_feedback_cancel(inputs)
	if (locale === "ru") return ru_feedback_cancel(inputs)
	if (locale === "it") return it_feedback_cancel(inputs)
	return en_feedback_cancel(inputs)
});